import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/auth/register/code/page";

export const Route = createFileRoute("/auth/register/code/")({
  component: Page,
});
